import Header from "./components/Header";
import Hero from "./components/Hero";
import HotBar from "./components/HotBar";
import Playground from "./components/Playground";
import FeedArea from "./components/FeedArea";
import Levels from "./components/Levels";
import Facts from "./components/Facts";
import CtaFooter from "./components/CtaFooter";
import FloatWidget from "./components/FloatWidget";

export default function Home() {
  return (
    <main className="w-full bg-background-50 text-foreground-950">
      <Header />
      <Hero />
      <HotBar />
      <Playground />
      <FeedArea />
      <Levels />
      <Facts />
      <CtaFooter />
      <FloatWidget />
    </main>
  );
}